import {keys} from 'ramda';
import {withRouter} from 'react-router';
import {withProps, lifecycle} from 'recompose';
import {connect} from 'react-redux';
import {resetRequests} from '@redux-requests/core';
import {bindActionCreators} from 'redux';
import api, {getMutation} from 'api';
// import errorMessages from './errorMessages';

export default name => Component =>
  Component
  |> withProps(({mutationFullname, ...props}) => {
    const {loading, error, data} = props[`${mutationFullname}Data`];

    const requestError = [];
    if (error && error?.request?.response) {
      const errorResponse = JSON.parse(error.request.response);
      keys(errorResponse.errors).forEach(e => {
        requestError.push(errorResponse.errors[e].join(' '));
      });
      if (errorResponse.code) {
        requestError.push(errorResponse.code);
      }
    } else if (error?.response?.data?.code) {
      requestError.push(error.response.data.code);
    }
    return {mutationLoading: loading, requestError, mutationData: data};
  })
  |> lifecycle({
    componentWillUnmount() {
      this.props.resetRequests([this.props.action.toString()]);
    },
  })
  |> connect(
    (state, {action, mutationFullname}) => ({
      [`${mutationFullname}Data`]: getMutation(state, action),
    }),
    (dispatch, {action, mutationFullname}) => ({
      dispatch,
      ...bindActionCreators({[mutationFullname]: action, resetRequests}, dispatch),
    }),
  )
  |> withProps(() => ({mutationFullname: name, action: api[name]}))
  |> withProps(({match}) => (match?.params ? {id: match.params?.id, page: match.params?.page} : {}))
  |> withRouter;
